import React, {forwardRef, useEffect, useLayoutEffect, useState} from "react";
import {getImagePathWithTheme} from "../../../../../src/utils";
import {Popover,Tooltip} from 'antd'
import i18next from "i18next";
import Global from "../../../../../src/global";

const ChooseTextStyle = forwardRef((props:{handleMindMapToolbar:any}, ref) => {
    const [isShowContext,setIsShowContext] = useState(false);

    return(
        <Popover arrow={false} open={isShowContext} onOpenChange={(e)=>{
            setIsShowContext(e);
            Global.g_isKeepMindmapToolbarShow = e;
        }} trigger={['click']} placement={'bottom'}
                 overlayInnerStyle={{margin: '0', padding: '0 6px'}} align={{offset: [0, 12]}}
                 content={
            <div className={'flex-row-vertical-center'} style={{height: '38px', gap: '6px 0'}}>
                     <img className={'img-30 cursor-pointer hovered'}
                          src={getImagePathWithTheme('mindmap_toolbar_b', true)} onClick={(e) => {
                         e.stopPropagation();
                              props.handleMindMapToolbar({type: "bold"})
                     }}/>
                     <img className={'img-30 cursor-pointer hovered'}
                          src={getImagePathWithTheme('mindmap_toolbar_i', true)} onClick={(e) => {
                         e.stopPropagation();
                              props.handleMindMapToolbar({type: "italic"})
                     }}/>

                {
                    <>
                        <img className={'img-30 cursor-pointer hovered'}
                             src={getImagePathWithTheme('mindmap_toolbar_u', true)} onClick={(e) => {
                            e.stopPropagation();
                            props.handleMindMapToolbar({
                                type: "underline",
                            })
                        }}/>
                        <img className={'img-30 cursor-pointer hovered'}
                             src={getImagePathWithTheme('mindmap_toolbar_s', true)} onClick={(e) => {
                            e.stopPropagation();
                            props.handleMindMapToolbar({
                                type: "strike",
                            })
                        }}/>
                    </>
                }

            </div>}>
            <Tooltip arrow={false} title={i18next.t("Text style")}>
                <img className={'img-30 cursor-pointer hovered'} onMouseDown={(e) => {
                    e.stopPropagation();
                }}
                     src={getImagePathWithTheme('mindmap_toolbar_style', true)}/></Tooltip>
        </Popover>
    )
})

export default ChooseTextStyle;